"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxObservable = require("redux-observable");

var _ramda = require("ramda");

var _operators = require("rxjs/operators");

var _services = require("@alycecom/services");

var _personalGeneralSettings = require("./personalGeneralSettings.helpers");

var actions = _interopRequireWildcard(require("./personalGeneralSettings.actions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var transformErrors = function transformErrors(error) {
  return _objectSpread(_objectSpread({}, error), {}, {
    errors: (0, _personalGeneralSettings.transformGeneralSettingsErrors)(error.errors || {})
  });
};

var getGeneralSettingsEpic = function getGeneralSettingsEpic(action$, state$, _ref) {
  var personalSettingsService = _ref.personalSettingsService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(actions.getSettings), (0, _operators.mergeMap)(function () {
    return personalSettingsService.getGeneralSettings().pipe((0, _operators.mergeMap)(function (response) {
      return [actions.getSettingsSuccess((0, _personalGeneralSettings.transformGeneralSettingsResponse)(response.settings))];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: actions.getSettingsFail
    })), (0, _operators.takeUntil)(action$.ofType(actions.getSettings)));
  }));
};

var setRoleEpic = function setRoleEpic(action$, state$, _ref2) {
  var personalSettingsService = _ref2.personalSettingsService,
      _ref2$messagesService = _ref2.messagesService,
      errorHandler = _ref2$messagesService.errorHandler,
      showGlobalMessage = _ref2$messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.setRole), (0, _operators.mergeMap)(function (_ref3) {
    var role = _ref3.payload;
    return personalSettingsService.setRole(role).pipe((0, _operators.mergeMap)(function () {
      return [actions.setRoleSuccess(role), showGlobalMessage({
        text: 'Changes saved',
        type: 'success'
      }), _services.TrackEvent.actions.trackEvent({
        name: 'Profile settings role — updated'
      })];
    }), (0, _operators.catchError)(function (error) {
      return errorHandler({
        callbacks: actions.setRoleFail
      })(transformErrors(error));
    }), (0, _operators.takeUntil)(action$.ofType(actions.setRole)));
  }));
};

var setPhoneEpic = function setPhoneEpic(action$, state$, _ref4) {
  var personalSettingsService = _ref4.personalSettingsService,
      _ref4$messagesService = _ref4.messagesService,
      errorHandler = _ref4$messagesService.errorHandler,
      showGlobalMessage = _ref4$messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.setPhone), (0, _operators.mergeMap)(function (_ref5) {
    var phone = _ref5.payload;
    return personalSettingsService.setPhone(phone).pipe((0, _operators.mergeMap)(function () {
      return [actions.setPhoneSuccess(phone), showGlobalMessage({
        text: 'Changes saved',
        type: 'success'
      }), _services.TrackEvent.actions.trackEvent({
        name: 'Profile settings number — updated'
      })];
    }), (0, _operators.catchError)(function (error) {
      return errorHandler({
        callbacks: actions.setPhoneFail
      })(transformErrors(error));
    }), (0, _operators.takeUntil)(action$.ofType(actions.setPhone)));
  }));
};

var setNameEpic = function setNameEpic(action$, state$, _ref6) {
  var personalSettingsService = _ref6.personalSettingsService,
      _ref6$messagesService = _ref6.messagesService,
      errorHandler = _ref6$messagesService.errorHandler,
      showGlobalMessage = _ref6$messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.setName), (0, _operators.mergeMap)(function (_ref7) {
    var _ref7$payload = _ref7.payload,
        firstName = _ref7$payload.firstName,
        lastName = _ref7$payload.lastName;
    return personalSettingsService.setName({
      firstName,
      lastName
    }).pipe((0, _operators.mergeMap)(function () {
      return [actions.setNameSuccess({
        firstName,
        lastName
      }), showGlobalMessage({
        text: 'Changes saved',
        type: 'success'
      }), _services.TrackEvent.actions.trackEvent({
        name: 'Profile settings name — updated'
      })];
    }), (0, _operators.catchError)(function (error) {
      return errorHandler({
        callbacks: actions.setNameFail
      })(transformErrors(error));
    }), (0, _operators.takeUntil)(action$.ofType(actions.setName)));
  }));
};

var deleteAvatarEpic = function deleteAvatarEpic(action$, state$, _ref8) {
  var personalSettingsService = _ref8.personalSettingsService,
      _ref8$messagesService = _ref8.messagesService,
      errorHandler = _ref8$messagesService.errorHandler,
      showGlobalMessage = _ref8$messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.deleteAvatar), (0, _operators.mergeMap)(function () {
    return personalSettingsService.deleteAvatar().pipe((0, _operators.mergeMap)(function (response) {
      return [actions.deleteAvatarSuccess(response.image_url), showGlobalMessage({
        text: 'Avatar removed',
        type: 'success'
      }), _services.TrackEvent.actions.trackEvent({
        name: 'Profile settings photo — removed'
      })];
    }), (0, _operators.catchError)(function (error) {
      return errorHandler({
        callbacks: actions.deleteAvatarFail
      })(transformErrors(error));
    }), (0, _operators.takeUntil)(action$.ofType(actions.deleteAvatar)));
  }));
};

var setAvatarEpic = function setAvatarEpic(action$, state$, _ref9) {
  var personalSettingsService = _ref9.personalSettingsService,
      _ref9$messagesService = _ref9.messagesService,
      errorHandler = _ref9$messagesService.errorHandler,
      showGlobalMessage = _ref9$messagesService.showGlobalMessage,
      ERRORS = _ref9$messagesService.ERRORS;
  return action$.pipe((0, _reduxObservable.ofType)(actions.setAvatar), (0, _operators.mergeMap)(function (_ref10) {
    var file = _ref10.payload;
    return personalSettingsService.setAvatar(file).pipe((0, _operators.mergeMap)(function (response) {
      return [actions.setAvatarSuccess(response.image_url), showGlobalMessage({
        text: 'Changes saved',
        type: 'success'
      }), _services.TrackEvent.actions.trackEvent({
        name: 'Profile settings photo — uploaded'
      })];
    }), (0, _operators.catchError)(function (error) {
      return errorHandler({
        callbacks: [actions.setAvatarFail],
        message: (0, _ramda.pathOr)(ERRORS.INTERNAL_SERVER_ERROR, ['errors', 'image'], error)
      })(transformErrors(error));
    }), (0, _operators.takeUntil)(action$.ofType(actions.setAvatar)));
  }));
};

var setFunFactsEpic = function setFunFactsEpic(action$, state$, _ref11) {
  var personalSettingsService = _ref11.personalSettingsService,
      _ref11$messagesServic = _ref11.messagesService,
      errorHandler = _ref11$messagesServic.errorHandler,
      showGlobalMessage = _ref11$messagesServic.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.setFunFacts), (0, _operators.mergeMap)(function (_ref12) {
    var _ref12$payload = _ref12.payload,
        funFacts = _ref12$payload.funFacts,
        showFunFacts = _ref12$payload.showFunFacts;
    return personalSettingsService.setFunFacts({
      funFacts,
      showFunFacts
    }).pipe((0, _operators.mergeMap)(function () {
      return [actions.setFunFactsSuccess({
        funFacts,
        showFunFacts
      }), showGlobalMessage({
        text: 'Changes saved',
        type: 'success'
      }), _services.TrackEvent.actions.trackEvent({
        name: 'Profile settings fun facts — updated'
      })];
    }), (0, _operators.catchError)(function (error) {
      return errorHandler({
        callbacks: actions.setFunFactsFail
      })(transformErrors(error));
    }), (0, _operators.takeUntil)(action$.ofType(actions.setFunFactsFail)));
  }));
};

var personalGeneralSettings = [getGeneralSettingsEpic, setAvatarEpic, deleteAvatarEpic, setNameEpic, setPhoneEpic, setRoleEpic, setFunFactsEpic];
var _default = personalGeneralSettings;
exports.default = _default;